var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShowDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visibility-24px_1_",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    className: "st0",
    d: "M12,5.75C7.9505367,5.7523212,4.3145704,8.2312994,2.8329999,12 c1.9865897,5.0625191,7.7010202,7.5560513,12.7635384,5.5694618C18.1469975,16.568634,20.1651707,14.5504589,21.1660004,12 C19.6845627,8.231638,16.0490971,5.7527318,12,5.75z M12,16.1669998c-2.3013706,0-4.1669998-1.8656292-4.1669998-4.1669998 S9.6986294,7.8330002,12,7.8330002S16.1669998,9.6986294,16.1669998,12l0,0 C16.1664467,14.3011417,14.3011417,16.1664467,12,16.1669998z M12,9.5c-1.3807116,0-2.5,1.1192884-2.5,2.5s1.1192884,2.5,2.5,2.5 s2.5-1.1192884,2.5-2.5S13.3807116,9.5,12,9.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShowDocument);
export default __webpack_public_path__ + "static/media/Icon_ShowDocument.3804307d5fc0f1977c87650eb54104ca.svg";
export { ForwardRef as ReactComponent };